/** Resolve Firebase Storage bucket from env or project id default. */
export function resolveStorageBucket(
  projectId: string,
  envBucket?: string | null,
): string {
  const trimmed = envBucket?.trim()
  if (trimmed) {
    return trimmed.replace(/^gs:\/\//, '')
  }
  return `${projectId}.firebasestorage.app`
}
